import React from 'react';

import config from './Modal.config';
import './Modal.less';

const Modal = ({ visible, onClose, title, description, image }) => (
  <div className={`modal ${visible ? 'show' : ''}`}>
    <div className="modal-wrapper">
      <div className="modal-content set-center">
        <h1 className="title-text" id="text_titleModal">
          {title}
        </h1>
        <p id="text_descModal">{description}</p>
        {image && <img src={image} className="modal-image" alt="modalImage" />}
        <button
          id="btn_closeModal"
          type="button"
          onClick={onClose}
          className="primary"
        >
          OK
        </button>
      </div>
    </div>
  </div>
);

Modal.propTypes = config.propTypes;
Modal.defaultProps = config.defaultProps;
Modal.componentDetail = config.componentDetail;
Modal.builderConfig = config.builderConfig;

export default Modal;
